// extracted by mini-css-extract-plugin
module.exports =  {"radio":"Radio-module__radio___sLkUk","radio_readOnly":"Radio-module__radio_readOnly___yYoOC"};